import { Box } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';

const StatusNotStartedIcon = ({ sx }) => {
  return (
    <Box
      sx={{
        width: '35px',
        height: '35px',
        backgroundColor: '#9c9a97',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#fff',
        ...sx,
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
          stroke="#fff"
        />
        <path
          opacity="0.4"
          d="M3.40991 22C3.40991 18.13 7.25991 15 11.9999 15C12.9599 15 13.8899 15.13 14.7599 15.37"
          stroke="#fff"
        />
        <path
          d="M22 18C22 18.32 21.96 18.63 21.88 18.93C21.79 19.33 21.63 19.72 21.42 20.06C20.73 21.22 19.46 22 18 22C16.97 22 16.04 21.61 15.34 20.97C15.04 20.71 14.78 20.4 14.58 20.06C14.21 19.46 14 18.75 14 18C14 16.92 14.43 15.93 15.13 15.21C15.86 14.46 16.88 14 18 14C19.18 14 20.25 14.51 20.97 15.33C21.61 16.04 22 16.98 22 18Z"
          stroke="#fff"
        />
        <path d="M19.0299 16.94L16.9199 19.05" stroke="#fff" />
        <path d="M16.9399 16.96L19.0599 19.07" stroke="#fff" />
      </svg>
    </Box>
  );
};

StatusNotStartedIcon.propTypes = {
  sx: PropTypes.object,
};

StatusNotStartedIcon.defaultProps = {};
export default StatusNotStartedIcon;
